<script setup lang="ts">
import { PresentationType, type MessagesComponents as components } from '@core/types'
import { computed, useUserInfo, useUserNotifications, watch } from '#imports'

const MAX_VISIBLE_FLASHES = 3

const { isLoggedIn } = useUserInfo()

const { flashes, markAsShown, markAsRead } = useUserNotifications({
    exclude_expired: true,
    exclude_read: true,
    presentation_type: PresentationType.flash,
    key: 'notification:flashes',
    lazy: true,
    enabled: isLoggedIn,
})
const visibleFlashes = computed(() => flashes.value.slice(0, MAX_VISIBLE_FLASHES))

function onDismiss(flash: components['schemas']['RenderedNotification']) {
    markAsRead.mutate({ notifications: [flash] })
}

watch(visibleFlashes, (flashes, previousFlashes) => {
    flashes
        .filter(flash => !previousFlashes?.some(prev => prev.id === flash.id))
        .forEach(flash => markAsShown.mutate(flash))
}, { immediate: true })
</script>

<template>
    <div v-if="visibleFlashes.length" class="notification-flash-container">
        <NimbusNotificationFlashDefaultMessage
            v-for="flash in visibleFlashes"
            :key="flash.id"
            :notification="flash"
            @dismiss="onDismiss(flash)"
        />
    </div>
</template>

<style lang="scss" scoped>
.notification-flash-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
}
</style>
